import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, CustomTable } from '../helpComponents/Table';
import axios from 'axios';
function Dashboard() {
    const navigate = useNavigate();
    const [col, setCol] = useState([]);
    const [Members, setMembers] = useState([]);
    const [houseHolds, setHouseHolds] = useState([]);
    const [colHouseHolds, setColHouseHolds] = useState([]);
    const [colSpouses, setColSpouses] = useState([]);
    const [colChildren, setColChildren] = useState([]);
    const [spouses, setSpouses] = useState([]);
    const [children, setChildren] = useState([]);
    const membersfromAPI = async () => {
        //http://localhost:3001/member
        //https://n2m4hmwxiw.us-east-1.awsapprunner.com/member
        await axios.get('https://n2m4hmwxiw.us-east-1.awsapprunner.com/member')
            .then(async res => {
                console.log('response', res.data.message);
                setMembers(res.data.message);
            })
            .catch(err => {
                console.log(err);
            });

    };
    useEffect(() => {
     const test = async () => {
           await membersfromAPI();
            await allMembers();
        }
    }, []);
    const allMembers = async () => {
        let tempMembers = [];
        const test =await (()=> membersfromAPI())();
        console.log('Members', Members)
        Members.map((member, index) => {
            const tempMember = {
                firstName: member.householdMember.firstName,
                middleName: member.householdMember.middleName,
                lastName: member.householdMember.lastName,
                gender: member.householdMember.gender,
                dob: member.householdMember.dob,
                phone: member.householdMember.phone,
                email: member.householdMember.email
            }
            tempMembers.push(tempMember);
        }
        )
        // console.log('tempMembers', tempMembers);
        setHouseHolds(tempMembers);
       
    let objectsKeys = [];
        if (tempMembers.length > 0) {
            Object.keys(tempMembers[0]).map((key, index) => {
                objectsKeys.push({id:key});
            })

            setColHouseHolds(objectsKeys);
        }
    }
    return (
        <div className="dashboardMainDiv">
            <div className='dashboardHeaderDiv'>
                <button onClick={allMembers}>View All Members</button>
            </div>
            {houseHolds.length > 0 && colHouseHolds && 
            <CustomTable data={houseHolds} columns={colHouseHolds} />}
        </div>)
}
export default Dashboard;